import React from "react";
import ConfirmationModal from "../../modal/ConfirmationModal/ConfirmationModal";

interface EditInfoModalProps {
  isOpened: boolean;
  onClose(): void;
  onSubmit(): void;
}

const title = "Attention";
const message =
  "La modification de promotion de vos disponibilités n’entraînera pas de modification sur le(s) rdv déjà pris";
const confirmText = "J'ai compris";

function EditInfoModal(props: EditInfoModalProps) {
  const { isOpened, onClose, onSubmit } = props;
  return (
    <ConfirmationModal
      title={title}
      message={message}
      confirmText={confirmText}
      cancelText=""
      isOpened={isOpened}
      onClose={onClose}
      onCancel={onClose}
      onConfirm={onSubmit}
      allowCancel={false}
    />
  );
}

export default EditInfoModal;
